<template>
  <div style="height: 100%; width: 100%">
    <div class="user-detail">
      <div class="user-detail-left">
        <div class="user-detail-left-img">
          <user-image
            :isEdit="isEdit"
            :imageUrl="detail.ImageUrl"
            @refresh="loadUserDetail"
            @refreshUrl="refreshUserImage"
          ></user-image>
          <!-- <img
            src="http://58.218.64.10:81/MJL/Upload/UserICON/89a2a6d8f29d4eb78465f6d3bd7fa581.jpg"
            alt="个人头像"
          /> -->
        </div>
        <div class="user-detail-left-name">姓名：{{ detail.DisplayName }}</div>
        <div class="user-detail-left-info">
          <div class="user-detail-left-dep">
            <i class="icon icon-bumen"></i>部门：{{ detail.DeptName }}
          </div>
          <div class="user-detail-left-phone">
            <i class="icon icon-phone"></i>电话：{{ detail.Phone }}
          </div>
        </div>
      </div>
      <div class="user-detail-right">
        <div class="user-detail-right-item">
          <span class="label">登录名：</span
          ><span class="content">{{ detail.LoginName }}</span>
        </div>
        <div class="user-detail-right-item">
          <span class="label">工号：</span
          ><span class="content">{{ detail.AgentNo }}</span>
        </div>
        <div class="user-detail-right-item">
          <span class="label">性别：</span
          ><span class="content">{{ detail.Gender }}</span>
        </div>
        <div class="user-detail-right-item">
          <span class="label">Email：</span
          ><span class="content">{{ detail.Email }}</span>
        </div>
        <div class="user-detail-right-item">
          <span class="label">手机：</span
          ><span class="content">{{ detail.MobilePhone }}</span>
        </div>
        <div class="user-detail-right-item">
          <span class="label">注册日期：</span
          ><span class="content">{{ detail.CreateTime }}</span>
        </div>
        <div class="user-detail-right-item">
          <span class="label">角色：</span
          ><span class="content">{{ roleName }}</span>
        </div>
      </div>
    </div>

    <div v-if="isEdit" class="user-operation">
      <el-button @click="editUser()">编辑</el-button
      ><el-button @click="editPassword()">修改密码</el-button>
      <el-button v-if="!IsSuperAdmin" @click="userSelectVisible = true">权限移交</el-button>
    </div>
    <user-select
      ref="userSelect"
      v-if="userSelectVisible"
      @submit="userSelectSubmit"
      :multiple="false"
      @closeCallback="userSelectVisible = false"
    ></user-select>
  </div>
</template>

<script>
import { getUserDetail } from "@/api/user";
import { transferAuthority } from "@/api/authority";
import UserImage from "./UserImage.vue";
import UserSelect from "./UserSelect.vue";
import moment from "moment";
export default {
  components: { UserImage, UserSelect },
  name: "UserDetail",
  props: {
    UserID: { type: String, required: true },
    isEdit: { type: Boolean, default: false },
  },
  computed: {
    roleName() {
      return this.detail.Roles.map((item) => {
        return item;
      }).join(",");
      return "";
    },
    userImage() {
      if (this.detail.ImageUrl)
        return process.env.VUE_APP_System_Api + this.detail.ImageUrl;
      else return "";
    },
    IsSuperAdmin(){
      if(this.$store.state.user.userInfo)
      {
        return this.$store.state.user.userInfo.IsSuperAdmin
      }
      else
      {
        return false
      }
    }
  },
  data() {
    return {
      detail: {
        DisplayName: "",
        ImageUrl: "",
        CreateTime: "",
        Phone: "",
        DeptName: "",
        Email: "",
        LoginName: "",
        MobilePhone: "",
        AgentNo: "",
        Gender: "",
        Roles: [],
      },
      userSelectVisible: false,
    };
  },
  mounted() {
    if (this.UserID) {
      this.loadUserDetail();
    }
  },
  methods: {
    userSelectSubmit(obj) {
      if (obj.length === 1) {
        transferAuthority({ UserID: obj[0].ID }).then((res) => {
          if (res.Code === 200) {
            this.$successMessage("移交成功，即将退出！");
            this.$store.dispatch("user/logout");
            this.$router.push(`/login`);
          }
        });
      }
      this.userSelectVisible = false;
    },
    authTransfer() {},
    loadUserDetail() {
      let that = this;
      getUserDetail({ id: this.UserID }).then((res) => {
        if (res.Code === 200) {
          that.detail = res.Data;
          if (that.detail.ImageUrl) {
            that.detail.ImageUrl =
              that.detail.ImageUrl +
              "?timespan=" +
              moment().format("YYYYMMDDHHmmss");
          }
        }
      });
    },
    editUser() {
      this.$emit("editUser");
    },
    editPassword() {
      this.$emit("editPassword");
    },
    refreshUserImage(url) {
      this.$store.commit(
        "user/mSetUserImage",
        url + "?timespan=" + moment().format("YYYYMMDDHHmmss")
      );
    },
  },
};
</script>

<style scoped  lang="scss">
.user-operation {
  display: flex;
  justify-content: center;
  bottom: 10px;
  position: absolute;
  width: 100%;
}
.user-detail {
  display: flex;
  justify-content: center;
  align-items: center;
  &-left {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40%;
    flex-direction: column;
    text-align: center;
    &-img {
      width: 130px;
      border-radius: 5px;
      // border: 1px solid #ccc;
      padding: 4px;
      // box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15);
      display: inline-block;
      img {
        width: 100%;
      }
    }
    &-name {
      width: 200px;
      background: #4fb9fc;
      padding: 4px;
      color: white;
      margin: 10px;
    }
    &-info {
      width: 200px;
      background: rgb(248, 250, 252);
      border: 1px solid #cccccc;
      text-align: left;
      text-indent: 20px;
      .icon {
        margin-right: 3px;
      }
      div {
        margin: 5px;
      }
    }
  }
  &-right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60%;
    flex-direction: column;
    &-item {
      width: 100%;
      padding: 8px;
      border-bottom: 1px dashed #e8e8e8;
      display: flex;
      .label {
        min-width: 113px;
        color: #525252;
        font-weight: bold;
      }
      .content {
        width: 60%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/UserDetail.vue